export default __webpack_public_path__ + "static/media/train_trainer_image.551fc0f8.svg";